import React from 'react';
import Helmet from 'react-helmet';
import { Formik } from 'formik';

import RegisterFeatures from '../RegisterView/components/RegisterFeatures';
import MainLayout from '../../layouts/MainLayout';
import RegisterAppSumoDetailsForm from './RegisterAppSumoDetailsForm';
import useAppSumoRegister from './useAppSumoRegister';

const RegisterAppSumo = () => {
  const { loading, onRegister } = useAppSumoRegister();

  const onSubmit = values => {
    onRegister(values);
  };

  const supportText = (
    <p className="mb-0 text-dark text-bold">
      Have questions?{' '}
      <a href="mailto:support@waldophotos.com">Contact support</a>
    </p>
  );

  return (
    <MainLayout className="view-register">
      <Helmet>
        <title>Register &ndash; Waldo</title>
      </Helmet>

      <div className="container py-6">
        <div className="row">
          <div className="col-md-6 col-12">
            <div className="view-register-title-header">
              <h2>Welcome to Waldo&rsquo;s Photo Manager</h2>
            </div>

            <RegisterFeatures
              className="d-none d-md-block"
              supportText={supportText}
            />
          </div>
          <div className="col-md-6 col-12 pl-xl-6">
            <h4 className="view-register-form-title">
              <span className="view-register-form-title-main">About you</span>
            </h4>

            <Formik
              initialValues={{
                first_name: '',
                last_name: '',
                organization_name: '',
                email_address: '',
                password: '',
                password_confirm: '',
                app_sumo_code: '',
                terms_checked: false,
              }}
              validate={async values => {
                return (async () => {
                  const errors = {};

                  if (values.password !== values.password_confirm) {
                    errors.password_confirm = 'Passwords must match';
                  }

                  if (!values.app_sumo_code) {
                    errors.app_sumo_code =
                      'Please enter your AppSumo redemption code';
                  }

                  if (Object.keys(errors).length > 0) {
                    throw errors;
                  }
                })();
              }}
              onSubmit={onSubmit}
              validateOnBlur={false}
              validateOnChange={false}
              render={({
                values,
                handleSubmit,
                handleChange,
                handleBlur,
                errors,
                touched = {},
              }) => {
                return (
                  <RegisterAppSumoDetailsForm
                    values={values}
                    handleSubmit={handleSubmit}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                    loading={loading}
                  />
                );
              }}
            />

            <RegisterFeatures
              className="mt-5 d-md-none"
              supportText={supportText}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default RegisterAppSumo;
